import React, {useState, useEffect} from 'react';
import useInterval from 'react-useinterval';

import {
  Header,
  Modal,
  Progress,
  Grid,
  Input,
  Button
} from 'semantic-ui-react';

export default props => {
  const {
    isShowing,
    onHide,
    defaultJobName
  } = props;

  const [runPercent, setRunPercent] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const [jobName, setJobName] = useState(defaultJobName);

  useEffect(() => {
    setJobName(defaultJobName);
    setRunPercent(0);
    setIsRunning(false);
  }, [isShowing]);

  const incrementPercent = () => {
    if (runPercent < 100)
      setRunPercent(runPercent + 20);
  };

  useInterval(incrementPercent, isRunning ? 1000 : null);

  const handleRunStart = () => {
    setIsRunning(true);
    setRunPercent(0);
  };

  const RunForm = () => (
    <div>
      <Grid columns={6} stretched>
        <Grid.Column width={2} className="align-center">
          Job name:
        </Grid.Column>
        <Grid.Column width={4}>
          <Input value={jobName}/>
        </Grid.Column>
      </Grid>
      <Button onClick={handleRunStart}>Run</Button>
    </div>
  );

  const ProgressInfo = () => (
    <div>
      <p>The tool is running...</p>
      <Progress style={{height: 'initial'}} indicating autoSuccess percent={runPercent}/>
    </div>
  );

  return (
    <Modal
      onClose={onHide}
      open={isShowing}>
      <Header icon='play' content='Running FFE job' />
      <Modal.Content>
        {isRunning ? <ProgressInfo /> : <RunForm/> }
      </Modal.Content>
    </Modal>
  )
}